module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAGFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWNxwqAAAAB3RSTlMAQFV/E78GDc0aLgAAADxJREFUCNdjYGAQBAIGIGAuB4IAIIPdIEmNsQDEEFAvgjIYGChiOLBAGCLl5Y4QESUlZhCDFWSpAQPcGQDn3g4mxfYujQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/HellowWorld/phone_img.png
// module id = 8VrY
// module chunks = 41